import { render, staticRenderFns } from "./SmsTemplates.vue?vue&type=template&id=39618e3e&scoped=true"
import script from "./SmsTemplates.vue?vue&type=script&lang=js"
export * from "./SmsTemplates.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplates.vue?vue&type=style&index=0&id=39618e3e&prod&scoped=true&lang=css"
import style1 from "./SmsTemplates.vue?vue&type=style&index=1&id=39618e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39618e3e",
  null
  
)

export default component.exports